<div id="head"></div>
<h1 class="sr-only">Code Snippet Image Generator - Turn Code Into A Shareable PNG</h1>

<!-- ===================== Hero: the tool itself, the code on the left and its picture on the right ===================== -->
<div class="default-section initial-section metallic-section no-buttons wp-hero" data-section="top">
  <div class="cp-hero-head">
    <!-- the picture's own title on top (snippet.ts), as every tool shows what it makes; the tool's name without a window bar -->
    <p class="tools-title" aria-hidden="true">{{ state.windowBar && state.title ? state.title : 'Code Snippet Image Generator' }}</p>
    <p class="tools-subtitle">{{ state.language.label }} in {{ state.theme.name }} Theme</p>
  </div>

  <app-code-image-widget [themeKey]="themeKey" [languageKey]="languageKey" (stateChange)="onState( $event )"
                         (pick)="syncUrl( $event )" (previewClick)="scrollToSection( 'preview' )"></app-code-image-widget>
</div>

<nav class="cp-chipbar" appStuck aria-label="Code snippet image generator sections">
  <div class="cp-chipbar-row">
    <a *ngFor="let s of pageSections" class="pl-chip" [class.on]="activeSection === s.key" [attr.href]="'#sec-' + s.key"
       (click)="$event.preventDefault(); scrollToSection( s.key )">
      <span>{{ s.label }}</span>
    </a>
  </div>
</nav>

<div class="cp-body cp-boxes">
  <div class="cp-content">

    <!-- Preview: the picture whole, at its full height, and its download (owner 2026-10-13) -->
    <section class="cp-section" id="sec-preview" data-section="preview">
      <header class="cp-head">
        <h2 class="cp-h2">Preview</h2>
        <p class="cp-section-lead">Your picture whole, as the download will be. Pick its size and save it</p>
      </header>
      <div class="cp-main">
        <div class="ci-full" [class.ci-full-clear]="state.backdrop === 'none'">
          <canvas #full class="ci-full-canvas" role="img" [attr.aria-label]="'Your ' + state.language.label + ' code in the ' + state.theme.name + ' theme, full size'"></canvas>
        </div>
        <div class="ci-actions">
          <button type="button" class="cp-std-btn wp-btn-primary ci-btn ci-btn-download" (click)="download()">
            <app-icon name="download" aria-hidden="true"></app-icon>Download PNG
          </button>
          <span class="ci-scales" role="group" aria-label="Download size">
            <button type="button" class="cp-std-btn ci-toggle" *ngFor="let s of SCALES" [class.on]="s === exportScale" [attr.aria-pressed]="s === exportScale" (click)="setScale( s )">{{ s }}x</button>
          </span>
          <span class="ci-meta" *ngIf="imageWidth">{{ exportSize }}<ng-container *ngIf="truncated">, first 300 lines</ng-container></span>
        </div>
      </div>
    </section>

    <!-- Color Vision Deficiency: the picture with every colour of the theme seen through each condition (owner
         2026-10-13, as on the gradient and wallpaper tools) -->
    <section class="cp-section" id="sec-vision" data-section="vision">
      <header class="cp-head">
        <h2 class="cp-h2">Color Vision Deficiency</h2>
        <p class="cp-section-lead">How your picture reads to people with color vision deficiencies, through each condition</p>
      </header>
      <div class="cp-main ci-cvd">
        <div class="cp-cv-group" *ngFor="let group of cvdPictures">
          <h3 class="cp-h3">{{ group.group }}</h3>
          <div class="wp-cv-grid">
            <div class="wp-cv-item" *ngFor="let item of group.items">
              <div class="wp-cv-frame"><img *ngIf="item.url" [src]="item.url" [alt]="'Your code image with ' + item.name" decoding="async" loading="lazy"></div>
              <p class="cp-cv-cap"><span class="cp-cv-name">{{ item.name }}:</span> <span class="cp-cv-desc">{{ item.note }}</span></p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- More Color Tools (owner 2026-10-22): the Color Picker, above How It Works (no Related Themes or blog here) -->
    <app-more-tools sectionKey="more" title="More Color Tools" lead="Pick any color on your screen and read it the same way, right from your menu bar"
                    [app]="colorPicker" [source]="moreToolsSource"></app-more-tools>

    <app-tool-about [lead]="aboutLead" [paragraphs]="aboutParagraphs" [faq]="faq" ratingKey="code-snippet" ratingName="the Code Snippet Image Generator"></app-tool-about>
  </div>
</div>
